import { Link } from "react-router-dom";
import { foundationName, foundationWebsite } from "../../lib/foundation";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-shell footer-grid">
        <div className="footer-foundation-lockup">
          <p className="footer-brand">Guiding Stars</p>
          <p className="footer-endorsement">
            Guiding Stars is an internal program of {foundationName}.
          </p>
          <a href={foundationWebsite} target="_blank" rel="noreferrer">
            <img
              src="/images/guided-pathway-foundation-official-logo.webp"
              alt="The Guided Pathway Foundation"
            />
          </a>
        </div>
        <div>
          <p className="footer-heading">Guiding Stars</p>
          <Link to="/about">About</Link>
          <Link to="/#how-it-works">How It Works</Link>
          <Link to="/get-involved">Get Involved</Link>
        </div>
        <div>
          <p className="footer-heading">Members</p>
          <Link to="/atlas">My Atlas</Link>
          <Link to="/sign-in">Sign In</Link>
        </div>
        <div>
          <p className="footer-heading">Foundation</p>
          <a href={foundationWebsite} target="_blank" rel="noreferrer">
            The Guided Pathway Foundation
          </a>
          <a href="mailto:info@theguidedpathwayfoundation.com">Contact</a>
          <Link to="/privacy">Privacy</Link>
          <Link to="/accessibility">Accessibility</Link>
          <Link to="/terms">Terms</Link>
          <nav className="footer-social-links" aria-label="Social media">
            <a
              href="https://www.facebook.com/guidedpathwayfoundation"
              target="_blank"
              rel="noopener"
              aria-label="The Guided Pathway Foundation on Facebook"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                  d="M13.4 21v-8.2h2.8l.4-3.2h-3.2v-2c0-.9.3-1.6 1.6-1.6h1.7V3.1c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.3H7.2v3.2H10V21h3.4Z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/theguidedpathwayfoundation"
              target="_blank"
              rel="noopener"
              aria-label="The Guided Pathway Foundation on Instagram"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <rect
                  x="3.25"
                  y="3.25"
                  width="17.5"
                  height="17.5"
                  rx="5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="4.1"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                />
                <circle cx="17.6" cy="6.7" r="1.15" fill="currentColor" />
              </svg>
            </a>
          </nav>
        </div>
      </div>
      <div className="site-shell footer-bottom">
        <span>© {new Date().getFullYear()} The Guided Pathway Foundation</span>
        <span>Guiding Stars · Service, learning, and recognition</span>
      </div>
    </footer>
  );
}
